import React, { FC } from 'react';
import { Bal } from '@shared/api';
import { formats } from '@shared/utils';
import { balanceTypes } from './constants';
import { acceptUTC } from '../../lib';
import './Balance.scss';

const formatBalanceValue = (value: number, type: string) => {
    return `${type === 'DBIT' ? '-' : ''}$${value}`;
};

interface IBalanceInfoProps {
    date: string;
    balance: string;
    balanceType: string;
}

const BalanceInfo: FC<IBalanceInfoProps> = (props) => {
    const { date, balance, balanceType } = props;

    return (
        <div className='balance-info__info-items'>
            <div className='balance-info__info-item'>
                <span className='balance-info__info-header'>Date:</span>
                <span className='balance-info__info-content'>{acceptUTC(date, formats.fullTime)}</span>
            </div>
            <div className='balance-info__info-item'>
                <span className='balance-info__info-header'>{balanceType}:</span>
                <span className='balance-info__info-content'>{balance}</span>
            </div>
        </div>
    );
};

interface IBalanceProps {
    balance: Bal[];
}

export const Balance: React.FC<IBalanceProps> = ({ balance }) => {
    if (!balance || !balance.length) {
        return <span>No data</span>;
    }

    return (
        <div className='iso-report-general-info'>
            {balance.map((balItem) => (
                <BalanceInfo
                    date={balItem.dt.item}
                    balance={formatBalanceValue(balItem.amt.value, balItem.cdtDbtInd)}
                    balanceType={balanceTypes[balItem.tp.cdOrPrtry.item as keyof typeof balanceTypes]}
                />
            ))}
        </div>
    );
};
